import { reportDomMutation } from "./report";

const DOM_MUTATION_PATTERN = /removeChild|insertBefore/;

/**
 * Escucha errores no capturados y reporta los que tienen la firma del bug de
 * mutación externa. No los suprime: el error sigue su curso normal.
 */
export function installGlobalHandler() {
  window.addEventListener("error", (event) => {
    const message = event.message ?? "";
    const name = (event.error as Error | undefined)?.name ?? "";

    // OR, no AND: en errores cross-origin event.error viene null, y el nombre
    // del método NO se traduce aunque el mensaje sí ("Error al ejecutar
    // 'removeChild' en 'Node'"). Cualquiera de las dos señales alcanza.
    if (name !== "NotFoundError" && !DOM_MUTATION_PATTERN.test(message)) return;

    reportDomMutation({
      op: "global-handler",
      error: event.error as Error | undefined,
    });
  });
}
